<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      size="400Auto"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>修改价格</span>
    </template>
    <template #content>

      <el-row type="flex">
        <div>
          <el-form
              :model="form"
              ref="form"
              label-position="right"
              label-width="120px"
          >

            <el-form-item
                prop="yourPrice"
                label="原价"
                :rules="[
                      $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')
                    ]"
            >
              <gj-input :width="inputWidth" v-model="form.yourPrice">
                <template slot="prepend">$</template>
              </gj-input>
            </el-form-item>

            <el-form-item
                label="优惠价"
                prop="salePrice"
                :rules="[
                      $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数')
                    ]"
            >
              <gj-input :width="inputWidth" v-model="form.salePrice">
                <template slot="prepend">$</template>
              </gj-input>
            </el-form-item>

            <el-form-item label="优惠开始日期">
              <gj-date-picker
                  v-model="form.saleStartDate"
                  :width="inputWidth"
              ></gj-date-picker>
            </el-form-item>

            <el-form-item label="优惠结束日期">
              <gj-date-picker
                  v-model="form.saleEndDate"
                  :width="inputWidth"
              ></gj-date-picker>
            </el-form-item>

          </el-form>
        </div>
      </el-row>

    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "@/minxins";
import {adjustPrice} from "@/api/sale";
import {convertToDate} from "@/utils/date.util";

export default {
  name: "sale-instant-single-offer-modal",
  mixins: [modalMixIn, formRuleMixin],
  props:{
    params:null
  },
  data() {
    return {
      form: {},
      inputWidth: '200px',
    }
  },
  created() {
    this.form = this.params
  },
  methods:{
    confirm() {
      this.confirmLoading = true;
      adjustPrice(this.form.id, {
        ...this.form,
        saleStartDate: convertToDate(this.form.saleStartDate),
        saleEndDate: convertToDate(this.form.saleEndDate),
      })
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$emit('after');
          })
          .complete(() => this.confirmLoading = false);
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
</style>